<template>
  <div>
    <AppBarChart :bar-data="percentageData" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { format } from "d3-format";

import AppBarChart from "@/components/AppBarChart.vue";

export default {
  components: {
    AppBarChart
  },
  props: {
    sectionNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(["filteredImpactIndexData"]),
    rawData() {
      return this.filteredImpactIndexData();
    },
    percentageData() {
      return this.filteredImpactIndexData().map(d => {
        return {
          key: d.key,
          label: this.$t(`filters.legalProblems.legalProblem.options.${d.key}`),
          value: d.value,
          formated: d.value ? format(".0%")(d.value) : "",
          color: this.$vuetify.theme.themes.light[
            `section${this.sectionNumber}`
          ]
        };
      });
    }
  }
};
</script>

<style>
</style>